import { render } from "./OurClients.vue?vue&type=template&id=b415ab3c"
import script from "./OurClients.vue?vue&type=script&lang=js"
export * from "./OurClients.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zhouyi/workplace/node/djweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__